import React from 'react';

const IconSave = props => (<svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
  <path d="M18 20.5H4c-1.378 0-2.5-1.121-2.5-2.5V4c0-1.378 1.122-2.5 2.5-2.5h12.207L20.5 5.793V18 C20.5 19.379 19.379 20.5 18 20.5z M4 2.5C3.173 2.5 2.5 3.173 2.5 4v14c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5 V6.207L15.793 2.5H4z M11 18c-1.93 0-3.5-1.57-3.5-3.5S9.07 11 11 11s3.5 1.57 3.5 3.5S12.93 18 11 18z M11 12 c-1.378 0-2.5 1.121-2.5 2.5S9.622 17 11 17c1.379 0 2.5-1.121 2.5-2.5S12.379 12 11 12z M14.5 8.5h-10v-5h10V8.5z M5.5 7.5h8v-3 h-8V7.5z" />
</svg>);

export default IconSave;
